import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/About/Hero/Hero";
import Box from "../../components/About/box/Box";
import BoxHead from "../../components/About/box/BoxHead";
import Accordion from '../../components/Accordion';
import UpButton from '../../components/UpButton';
import {products_last_part} from '../../Data/product_new' ;
import SubServPart from '../../components/SubServPart' ;
import HeaderSlider from '../../components/HeaderSlider';
//============================================
import styles from "./About.module.scss";
import { GoDotFill } from "react-icons/go";
import { Helmet } from "react-helmet";
import certificate_1 from '../../assets/certificates (1).jpg';
import certificate_2 from '../../assets/certificates (2).jpg';
// import certificate_3 from '../../assets/certificates (3).jpg';
import certificate_5 from '../../assets/certificates (5).png';
import certificate_4 from '../../assets/certificates (4).png';
// import certificate_6 from '../../assets/certificates (6).png';
//---------------
// import ISO_13485 from '../../assets/PDF/ISO 13485.pdf' ;
// import ISO_9001 from '../../assets/PDF/ISO 9001.pdf' ;
// import CE_Mark from '../../assets/PDF/CE Mark.pdf' ;
// import FDA from '../../assets/PDF/FDA 510(K).pdf' ;
// import IHE from '../../assets/PDF/IHE.pdf' ;
import millensys_profile from '../../assets/PDF/millensys_profile.pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faMedal } from '@fortawesome/free-solid-svg-icons'
import { Link } from "react-router-dom";
//== 
import  { useContext ,useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
//==


const About = ({scroll , lang}) => {
  //---
  const { toggleLanguage } = useContext(LanguageContext);
  useEffect(() => {
    toggleLanguage(lang)
  },);
  //--- 
  return (
    <div>
      <Helmet>
        <title>Millensys - About</title>
      </Helmet>
      <UpButton scroll={scroll} />
      <div>
        <Header />
        <Hero />
        <div className={styles["certification_container"]}>
          <div className={styles["title"]}>
            <h3>
            <span>MILLENSYS,</span> Check Our Profile
            </h3>
            <h4>
            <FontAwesomeIcon icon={faMedal} /> | GET TO KNOW MORE ABOUT US 
            <a href={millensys_profile} download className={styles.product_list}>
              <GoDotFill className={styles.product__list_bullet} /> MILLENSYS
            </a>
            </h4>
          </div>

          <div className={styles.certification}>
            {/* <a href={millensys_profile} download className={styles.box}><img src={certificate_6} alt="quality certificates" /></a> */}
            <Link className={styles.box}><img src={certificate_1} alt="quality certificates" loading="lazy"/></Link>
            <Link className={styles.box}><img src={certificate_2} alt="quality certificates" loading="lazy"/></Link>
            {/* <a href={CE_Mark} download className={styles.box}><img src={certificate_3} alt="quality certificates" /></a> */}
            <Link className={styles.box}><img src={certificate_4} alt="quality certificates" loading="lazy"/></Link>
            <Link  className={styles.box}><img src={certificate_5} alt="quality certificates" loading="lazy"/></Link>
          </div>
          
        </div>
        <HeaderSlider/>
        <Box/>
        <Accordion/>
        <BoxHead/>
        <SubServPart products={products_last_part} title={'Value For Everyone'} overview={'Create and deliver a value for all stakeholders'}/>
        <Footer />
      </div>
    </div>
  );
};

export default About;
